module.exports = __webpack_public_path__ + "src/img/artist/work04_3.jpg?7ec2520502b42e9832d96cc1a7fa50e2";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work04_3.jpg
// module id = 154
// module chunks = 0